// src/pages/CateringPage.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import '../styles/EventPackagePage.css';
import Footer from '../components/Footer';

import buffet1 from '../assets/buffet1.jpg';
import buffet2 from '../assets/buffet2.jpg';
import buffet3 from '../assets/buffet3.jpg';
import buffet4 from '../assets/buffet4.jpg';
import buffet5 from '../assets/buffet5.jpg';
import buffet6 from '../assets/buffet6.jpg';
import buffet7 from '../assets/buffet7.jpg';

const IMAGES = [buffet1, buffet2, buffet3, buffet4, buffet5, buffet6, buffet7];

const WHATSAPP_HREF =
  'https://wa.me/6590079953?text=Hi%20Lebua%20Thai%2C%20I%27d%20like%20to%20enquire%20about%20your%20Catering%20Services.';

const CateringPage = () => (
  <div className="event-package-page">
    <header className="event-package-hero">
      <span className="event-package-hero__eyebrow">Book for Events</span>
      <h1 className="event-package-hero__title">Catering Services</h1>
      <p className="event-package-hero__sub">
        Bring the bold flavours of Lebua Thai to your own venue. Our catering
        service offers a curated buffet spread of authentic Thai dishes,
        perfect for corporate functions, private parties, and special
        celebrations of any size.
      </p>
      <a
        href={WHATSAPP_HREF}
        className="btn btn-primary event-package-hero__cta"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FontAwesomeIcon icon={faWhatsapp} /> Enquire on WhatsApp
      </a>
    </header>

    <div className="event-package-grid">
      {IMAGES.map((img, i) => (
        <div key={i} className="event-package-item">
          <img
            src={img}
            alt={`Lebua Thai catering spread ${i + 1}`}
            loading="lazy"
          />
        </div>
      ))}
    </div>

    <section className="event-package-reserve">
      <h2>Planning an Event?</h2>
      <p>Tell us your headcount, date, and venue — we'll put together a spread that fits.</p>
      <a
        href={WHATSAPP_HREF}
        className="btn btn-primary"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FontAwesomeIcon icon={faWhatsapp} /> Enquire on WhatsApp
      </a>
    </section>

    <Footer />
  </div>
);

export default CateringPage;
